module.exports = __webpack_public_path__ + "static/media/ic_sent.c5414ee6.svg";